import Card from '../components/Card';
import StatusBadge from '../components/StatusBadge';
import type { Transaction } from '../types';

const deposits: Transaction[] = [
    {
        id: '1',
        amount: 500,
        status: 'completed',
        date: '2024-03-10',
        type: 'Bank Transfer',
        paymentMethod: 'ACH'
    },
    {
        id: '2',
        amount: 1000,
        status: 'pending',
        date: '2024-03-09',
        type: 'Credit Card',
        paymentMethod: 'Visa'
    }
];

export default function Deposits() {
    return (
        <div className="space-y-6">
            <h1 className="text-2xl font-bold text-gray-900">Deposits</h1>

            <Card>
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead>
                        <tr className="text-left border-b border-gray-200">
                            <th className="pb-3 font-semibold text-gray-600">Date</th>
                            <th className="pb-3 font-semibold text-gray-600">Amount</th>
                            <th className="pb-3 font-semibold text-gray-600">Payment Method</th>
                            <th className="pb-3 font-semibold text-gray-600">Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {deposits.map((deposit) => (
                            <tr key={deposit.id} className="border-b border-gray-100">
                                <td className="py-4 text-gray-600">{deposit.date}</td>
                                <td className="py-4 text-gray-900 font-medium">
                                    ${deposit.amount.toFixed(2)}
                                </td>
                                <td className="py-4">
                                    <div className="flex items-center">
                                        <span className="text-gray-900">{deposit.paymentMethod}</span>
                                        <span className="mx-2 text-gray-400">•</span>
                                        <span className="text-gray-600">{deposit.type}</span>
                                    </div>
                                </td>
                                <td className="py-4">
                                    <StatusBadge status={deposit.status} />
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </Card>
        </div>
    );
}